import { SCHEMA } from '@vedalib/editor/lib/brand'
import { useCallback, useMemo } from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { Typography } from 'components/uiKit/Typography'
import { BrandButtonFont, BrandFormFontBase, BrandGoBack } from 'services/Branding/components'
import { FONT_FIELDS } from 'services/Branding/fieldConfigs'
import { genSchema } from 'services/Branding/genSchema'
import { useElementFontCss, useElementFontValues, useUpdateSchema } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { ButtonBrandForms, ButtonFormBrandType } from './buttonTypes'

export const FONT_FORM_SCHEMA = genSchema(SCHEMA.button.font, {
  active: FONT_FIELDS.base,
  disabled: FONT_FIELDS.base,
})
const TypographyActive: ButtonFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.active}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.button.tags.active')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

const TypographyDisabled: ButtonFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.disabled}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.button.tags.disabled')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

const ButtonTypography: ButtonFormBrandType = ({ device, edited, setForm, element }) => {
  const values = useElementFontValues('button', device, element?.font)
  const styles = useElementFontCss('button', device, element?.font)

  const goBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <Padding bottom gap sides>
      <BrandGoBack onClick={goBack}>
        <Typography weight='medium'>{t('page.brand.tab.typography')}</Typography>
      </BrandGoBack>
      <BrandButtonFont
        edited={edited.font?.active}
        font='active'
        onClick={setForm}
        styles={styles.active}
        values={values.active}
      >
        {t('elements.button.tags.active')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited.font?.disabled}
        font='disabled'
        onClick={setForm}
        styles={styles.disabled}
        values={values.disabled}
      >
        {t('elements.button.tags.disabled')}
      </BrandButtonFont>
    </Padding>
  )
}

const FORM_MAP: ButtonBrandForms = {
  [BrandFormEnum.TYPOGRAPHY]: ButtonTypography,
  active: TypographyActive,
  disabled: TypographyDisabled,
}

export default FORM_MAP
